import type { BrowserOptions, EdgeOptions, NodeOptions } from '@sentry/nextjs';
import * as Sentry from '@sentry/nextjs';
import { env } from 'env';

const config: BrowserOptions & NodeOptions & EdgeOptions = {
  dsn: env.NEXT_PUBLIC_SHOP_SENTRY_DSN,
  sampleRate: 1,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // enabled: env.NEXT_PUBLIC_ENV === 'prod',
  enabled: true, // TODO: Enabled for launch, diable at a later date

  // these are set in Sentry as production and development
  environment: env.NEXT_PUBLIC_ENV === 'prod' ? 'production' : 'development',
  release: env.NEXT_PUBLIC_COMMIT_SHA,

  // Provides Sentry with the values of local variables at each level in the stacktrace
  includeLocalVariables: true,

  // TODO: Consider adding beforeSend filtering logic if needed for shop-specific errors
  // beforeSend(event, hint) {
  //   // Add custom error filtering here if needed
  //   return event;
  // },
};

export default config;
